<div class="text-textMedium text-15 text-small-breadcrumbs">
  <small> (<span *ngFor="let item of items; let idx = index">
      <span class="relative font-lg" *ngIf="idx !== 0">/</span>
      {{ item }}
    </span>)</small>
</div>
